// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"35912e97-168":"bbbc9dcbf4bc9eb4d167","35912e97-452":"3bd917397b37dfe63f12","35912e97-379":"ee418475880c568960dc","35912e97-83":"79911dd9c7524e3595c2"}[chunkId] + ".js";
};